import { Navigate, Outlet } from "react-router";
import { useCompanyConfigEnabled } from "../hooks/useCompanyConfigEnabled";

/**
 * Route guard for company-configuration and bulk-create flows under `/onboarding`.
 *
 * Nested inside `OnboardingLayout` (parent portal shell + `enable-onboarding`).
 * Adds the second gate (`enable-company-config`) for both Company Configurations
 * and Bulk create companies (dependent flows): while flags load, render nothing;
 * when off, redirect home; when on, render child routes.
 */
export function CompanyConfigLayout() {
  const { isLoaded, areFlagsOn } = useCompanyConfigEnabled();

  if (!isLoaded) {
    return null;
  }

  if (!areFlagsOn) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
